export default function SearchBar({ search, setSearch }) {
  return (
    <input
      type="text"
      name="search"
      id="search"
      placeholder="Rechercher..."
      className="border-black border h-12 w-[100%] px-2"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  );
}
